module.exports = __webpack_public_path__ + "media/images/mv-copy-38a7dd69.png";